import { useState, useEffect } from "react";
import axios from "axios";
import { Calendar, Users, UserCheck, MessageSquare, AlertCircle, TrendingUp } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const getToken = () => localStorage.getItem("admin_token");
const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

function StatCard({ icon: Icon, label, value, accent }) {
  return (
    <div className="bg-card border border-border/40 rounded-sm p-6" data-testid={`stat-${label.toLowerCase().replace(/\s/g, '-')}`}>
      <div className="flex items-center gap-3 mb-3">
        <div className={`w-9 h-9 rounded-sm flex items-center justify-center ${accent ? 'bg-[hsl(var(--accent))]/10' : 'bg-secondary'}`}>
          <Icon className={`w-4 h-4 ${accent ? 'text-[hsl(var(--accent))]' : 'text-muted-foreground'}`} strokeWidth={1.5} />
        </div>
        <span className="text-sm text-muted-foreground">{label}</span>
      </div>
      <p className="font-heading text-3xl tracking-tight font-medium">{value}</p>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/dashboard`, authHeaders())
      .then(r => setStats(r.data))
      .catch(() => {});
  }, []);

  if (!stats) return <div className="text-muted-foreground">Loading...</div>;

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-heading text-2xl tracking-tight font-medium mb-6">Dashboard</h1>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <StatCard icon={Calendar} label="Upcoming Events" value={stats.upcomingEvents} accent />
        <StatCard icon={Users} label="Total Bookings" value={stats.totalBookings} />
        <StatCard icon={UserCheck} label="Total Waitlist" value={stats.totalWaitlist} />
        <StatCard icon={TrendingUp} label="Today's Registrations" value={stats.todayRegistrations} accent />
        <StatCard icon={MessageSquare} label="WhatsApp Sent" value={stats.whatsappSent} />
        <StatCard icon={AlertCircle} label="WhatsApp Failed" value={stats.whatsappFailed} />
      </div>
    </div>
  );
}
